module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "content"
  }, [_c('el-row', {
    staticClass: "filter-header",
    attrs: {
      "gutter": 8
    }
  }, [_c('el-col', {
    staticClass: "text-right sort-container",
    attrs: {
      "span": 14
    }
  }, [_vm._v("\n\n      Sort by\n      "), _c('el-dropdown', {
    staticClass: "filter-dropdown",
    on: {
      "command": _vm.changeSorting
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v("\n          " + _vm._s(_vm.currentSorting) + " "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "title"
    }
  }, [_vm._v("title")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "submissions"
    }
  }, [_vm._v("submissions")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "last activity"
    }
  }, [_vm._v("last activity")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Search",
      "prefix-icon": "el-icon-search"
    },
    on: {
      "change": _vm.onSearch
    },
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.createForm
    }
  }, [_vm._v("New form")])], 1)], 1), _vm._v(" "), _c('forms-list', {
    on: {
      "form-settings": _vm.onFormSettings
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": (_vm.editedItem && _vm.editedItem._id) ? 'Form settings' : 'Create new form',
      "visible": _vm.showCreateForm
    },
    on: {
      "update:visible": function($event) {
        _vm.showCreateForm = $event
      }
    }
  }, [_c('settings-dialog', {
    attrs: {
      "item": _vm.editedItem
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bdaec69"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/Forms.vue
// module id = 393
// module chunks = 4